import { type StatementItemConstructor } from '@webapp/modules/accounts-payable/entities/StatementItem'
import { type StatementItemApiModel } from '../api-models/StatementItemApiModel'

export const mapStatementItemApiModel = (
  model: StatementItemApiModel
): StatementItemConstructor => ({
  id: model.id,
  creditcardId: model.creditcard,
  date: model.date,
  description: model.description,
  amount: model.amount,
  duplicateOf: model.duplicate_of,
  matchId: model.match,
})
